// Icons component that renders different SVG icons based on the 'icon' prop
const Icons = ({ icon, className = "", ...props }) => {
  // List of available icons and their corresponding SVG elements
  const iconsList = {
    "white-arrow": (
      <svg
        className={className}
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className=" transition-all duration-300 ease-linear group-hover:stroke-pink-bg"
          d="M15 1L1 15"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className=" transition-all duration-300 ease-linear group-hover:stroke-pink-bg"
          d="M3.33398 1H15.0007V12.6667"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    instagram: (
      <svg
        className={className}
        width="57"
        height="59"
        viewBox="0 0 57 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2188_101)">
          <circle cx="28.5" cy="28.877" r="28" fill="#6379EF" />
          <circle
            cx="28.5"
            cy="28.877"
            r="27"
            stroke="#051D9C"
            strokeWidth="2"
          />
        </g>
        <path
          d="M30.3603 18.71C31.4853 18.713 32.0563 18.719 32.5493 18.733L32.7433 18.74C32.9673 18.748 33.1883 18.758 33.4553 18.77C34.5192 18.82 35.2452 18.988 35.8822 19.2349C36.5422 19.4889 37.0982 19.8329 37.6542 20.3879C38.1628 20.8876 38.5563 21.4924 38.8071 22.1599C39.0541 22.7969 39.2221 23.5228 39.2721 24.5878C39.2841 24.8538 39.2941 25.0748 39.3021 25.2998L39.3081 25.4938C39.3231 25.9858 39.3291 26.5568 39.3311 27.6817L39.3321 28.4277V29.7377C39.3346 30.4671 39.3269 31.1965 39.3091 31.9256L39.3031 32.1196C39.2951 32.3446 39.2851 32.5656 39.2731 32.8316C39.2231 33.8966 39.0531 34.6216 38.8071 35.2596C38.5563 35.9271 38.1628 36.5318 37.6542 37.0315C37.1544 37.5402 36.5497 37.9337 35.8822 38.1845C35.2452 38.4315 34.5192 38.5995 33.4553 38.6495L32.7433 38.6795L32.5493 38.6855C32.0563 38.6995 31.4853 38.7065 30.3603 38.7085L29.6144 38.7095H28.3054C27.5757 38.712 26.8459 38.7044 26.1164 38.6865L25.9224 38.6805C25.6851 38.6715 25.4477 38.6612 25.2105 38.6495C24.1465 38.5995 23.4205 38.4315 22.7825 38.1845C22.1154 37.9336 21.511 37.5401 21.0116 37.0315C20.5025 36.5319 20.1087 35.9272 19.8576 35.2596C19.6106 34.6226 19.4426 33.8966 19.3926 32.8316L19.3626 32.1196L19.3576 31.9256C19.3392 31.1965 19.3308 30.4671 19.3326 29.7377V27.6817C19.3298 26.9524 19.3372 26.223 19.3546 25.4938L19.3616 25.2998C19.3696 25.0748 19.3796 24.8538 19.3916 24.5878C19.4416 23.5228 19.6096 22.7979 19.8566 22.1599C20.1083 21.4921 20.5028 20.8873 21.0126 20.3879C21.5117 19.8795 22.1157 19.486 22.7825 19.2349C23.4205 18.988 24.1455 18.82 25.2105 18.77C25.4765 18.758 25.6984 18.748 25.9224 18.74L26.1164 18.734C26.8456 18.7162 27.575 18.7085 28.3044 18.711L30.3603 18.71ZM29.3324 23.7098C28.0063 23.7098 26.7346 24.2366 25.7969 25.1743C24.8593 26.1119 24.3325 27.3837 24.3325 28.7097C24.3325 30.0358 24.8593 31.3075 25.7969 32.2452C26.7346 33.1828 28.0063 33.7096 29.3324 33.7096C30.6584 33.7096 31.9301 33.1828 32.8678 32.2452C33.8055 31.3075 34.3322 30.0358 34.3322 28.7097C34.3322 27.3837 33.8055 26.1119 32.8678 25.1743C31.9301 24.2366 30.6584 23.7098 29.3324 23.7098ZM29.3324 25.7098C29.7263 25.7097 30.1164 25.7873 30.4804 25.938C30.8444 26.0887 31.1752 26.3096 31.4538 26.5881C31.7324 26.8666 31.9534 27.1973 32.1042 27.5612C32.2551 27.9252 32.3327 28.3153 32.3328 28.7092C32.3329 29.1032 32.2553 29.4933 32.1046 29.8573C31.9539 30.2213 31.733 30.552 31.4545 30.8306C31.176 31.1093 30.8453 31.3303 30.4813 31.4811C30.1174 31.6319 29.7273 31.7096 29.3334 31.7096C28.5377 31.7096 27.7747 31.3936 27.2121 30.831C26.6495 30.2684 26.3334 29.5053 26.3334 28.7097C26.3334 27.9141 26.6495 27.151 27.2121 26.5884C27.7747 26.0259 28.5377 25.7098 29.3334 25.7098M34.5832 22.2099C34.2517 22.2099 33.9338 22.3416 33.6994 22.576C33.465 22.8104 33.3333 23.1283 33.3333 23.4598C33.3333 23.7914 33.465 24.1093 33.6994 24.3437C33.9338 24.5781 34.2517 24.7098 34.5832 24.7098C34.9147 24.7098 35.2327 24.5781 35.4671 24.3437C35.7015 24.1093 35.8332 23.7914 35.8332 23.4598C35.8332 23.1283 35.7015 22.8104 35.4671 22.576C35.2327 22.3416 34.9147 22.2099 34.5832 22.2099Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_2188_101"
            x="0.5"
            y="0.876953"
            width="56"
            height="58"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.180392 0 0 0 0 0.27451 0 0 0 0 0.780392 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2188_101"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2188_101"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    top: (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M11.47 2.47a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06l-6.22-6.22V21a.75.75 0 0 1-1.5 0V4.81l-6.22 6.22a.75.75 0 1 1-1.06-1.06l7.5-7.5Z"
          clipRule="evenodd"
        />
      </svg>
    ),
    dexscreener: (
      <svg
        className={className}
        width="57"
        height="59"
        viewBox="0 0 57 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2188_93)">
          <circle cx="28.5" cy="28.877" r="28" fill="#6379EF" />
          <circle
            cx="28.5"
            cy="28.877"
            r="27"
            stroke="#051D9C"
            strokeWidth="2"
          />
        </g>
        <path
          d="M27.8569 18.9498C26.5149 19.1451 25.4061 19.6618 24.3288 20.5816C23.9067 20.947 23.9067 20.947 23.6673 20.8651C23.346 20.7643 22.8168 20.4115 22.5774 20.1406C22.3317 19.8571 22.338 19.9579 22.6026 20.4808C23.0499 21.3754 24.0138 22.4968 25.1037 23.3977C25.7904 23.971 26.7543 24.6388 27.3087 24.9286L27.6553 25.1113L28.0333 24.9286C28.5562 24.6703 29.1358 24.6703 29.6398 24.9223L29.9926 25.105L30.3328 24.9349C32.0464 24.0718 34.3018 21.9613 35.0264 20.5375C35.3477 19.9075 35.3414 19.876 34.9318 20.2603C34.579 20.6005 34.012 20.9344 33.7915 20.9344C33.7348 20.9344 33.5773 20.821 33.445 20.6824C32.8906 20.1154 31.7062 19.4287 30.862 19.1766C29.8162 18.8742 28.8838 18.8049 27.8569 18.9498Z"
          fill="white"
        />
        <path
          d="M22.7113 23.0259C22.1569 24.267 22.075 24.7458 22.075 26.9005C22.075 29.4394 21.949 30.7183 21.5395 32.3122C21.319 33.169 20.8528 34.448 20.6197 34.8323C20.5567 34.9394 20.5 35.0654 20.5 35.1032C20.5 35.141 20.9977 34.7756 21.6088 34.2842C22.453 33.6038 22.7302 33.4147 22.7743 33.4777C22.8058 33.5282 23.1712 34.1267 23.5933 34.8071L24.362 36.0545L25.2188 35.2418C25.9559 34.5425 26.0819 34.4417 26.1449 34.5362C26.1827 34.5929 26.8001 35.5946 27.5246 36.7664C28.2428 37.9382 28.8413 38.8832 28.8476 38.8769C28.8539 38.8643 29.4524 37.8941 30.1706 36.716C30.8951 35.5379 31.5062 34.5488 31.5314 34.5173C31.5944 34.448 31.752 34.574 32.571 35.3552C32.9427 35.7017 33.264 35.9915 33.2892 35.9915C33.3207 35.9915 33.6735 35.4434 34.083 34.7756C34.4862 34.1141 34.8516 33.5282 34.8894 33.4903C34.9461 33.4273 35.2107 33.6101 36.0297 34.2653C36.6156 34.7378 37.1196 35.1347 37.1385 35.1473C37.1637 35.1599 37.0314 34.8197 36.8424 34.385C36.3069 33.1501 35.9352 31.7893 35.7399 30.3844C35.7021 30.0883 35.6454 28.7401 35.6202 27.3919C35.5824 25.5522 35.5446 24.834 35.4753 24.5253C35.3556 24.0213 35.091 23.2779 34.8768 22.8558L34.7193 22.5408L34.524 22.7865C34.4169 22.9251 34.1649 23.2275 33.9696 23.4606L33.6105 23.8764L33.7743 24.2796C33.8688 24.5127 33.9507 24.8592 33.9696 25.1112C34.0515 26.2453 33.1317 27.2029 31.8276 27.3415L31.4558 27.3793L31.4936 27.8581C31.5188 28.1542 31.5692 28.3621 31.6259 28.4062C31.6764 28.4503 32.1552 28.7338 32.6907 29.0362C33.2199 29.3449 33.642 29.6158 33.6294 29.6347C33.6168 29.6599 33.1947 29.9119 32.6907 30.1954C32.193 30.4726 31.6953 30.775 31.6007 30.8569C31.3235 31.09 30.8762 31.783 30.5234 32.5264C30.2462 33.106 29.4587 35.393 29.1626 36.464C28.9736 37.157 28.8539 37.5035 28.8161 37.4531C28.7909 37.4279 28.5893 36.7664 28.3562 35.9852C27.8522 34.2527 27.449 33.1375 27.0458 32.3185C26.4536 31.1341 26.2079 30.8758 24.929 30.1639C24.4313 29.8867 24.028 29.641 24.028 29.6221C24.028 29.5969 24.5132 29.3008 25.0991 28.9669L26.1701 28.3495V27.9967C26.1701 27.8014 26.189 27.5809 26.2079 27.499C26.2457 27.373 26.2268 27.3604 25.9937 27.3604C25.6346 27.3604 24.9731 27.1399 24.6203 26.9005C23.6878 26.2768 23.4673 25.2939 23.9713 24.0402C24.0469 23.8512 24.0406 23.8323 23.7256 23.4858C23.5492 23.2905 23.3098 23.007 23.2027 22.8495C23.0893 22.6983 22.9822 22.5723 22.957 22.5723C22.9318 22.5723 22.8247 22.7739 22.7113 23.0259Z"
          fill="white"
        />
        <path
          d="M24.8856 24.7083C24.8604 24.7461 24.8289 24.9099 24.8037 25.08C24.7281 25.7416 25.2888 26.2393 26.1141 26.2393C26.4606 26.2393 26.8953 26.1385 27.0087 26.0377C27.0402 26.0125 26.8701 25.8802 26.6307 25.7542C26.2716 25.5525 25.5093 25.0611 25.0368 24.7272C24.9612 24.6705 24.9108 24.6642 24.8856 24.7083Z"
          fill="white"
        />
        <path
          d="M32.2791 24.9597C32.0523 25.1236 31.5735 25.4323 31.2207 25.6402L30.5781 26.0245L30.8364 26.1253C30.9939 26.1883 31.2774 26.2324 31.5357 26.2324C32.4556 26.2387 32.9974 25.7032 32.8336 24.9408C32.8021 24.7833 32.7517 24.651 32.7328 24.6573C32.7076 24.6573 32.506 24.7959 32.2791 24.9597Z"
          fill="white"
        />
        <path
          d="M28.5963 25.8291C28.3884 25.8732 27.9852 26.1819 27.771 26.4591C27.4749 26.8497 27.3048 27.4167 27.267 28.1475C27.2166 29.0673 27.2418 29.0232 26.6937 29.3256L26.2148 29.584L26.366 29.7037C27.5001 30.5731 27.9411 31.2535 28.5333 33.0301L28.8294 33.9121L29.1381 32.9923C29.7114 31.3039 30.3162 30.3526 31.1541 29.8108C31.5069 29.584 31.5258 29.6218 30.8769 29.2563C30.6816 29.1429 30.4863 28.998 30.4548 28.935C30.417 28.872 30.3918 28.5633 30.3918 28.2609C30.3918 27.36 30.1776 26.7237 29.7177 26.2638C29.346 25.8858 28.9869 25.7472 28.5963 25.8291Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_2188_93"
            x="0.5"
            y="0.876953"
            width="56"
            height="58"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0627451 0 0 0 0 0.133333 0 0 0 0 0.509804 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2188_93"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2188_93"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    telegram: (
      <svg
        className={className}
        width="57"
        height="59"
        viewBox="0 0 57 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2188_104)">
          <circle cx="28.5" cy="28.877" r="28" fill="#6379EF" />
          <circle
            cx="28.5"
            cy="28.877"
            r="27"
            stroke="#051D9C"
            strokeWidth="2"
          />
        </g>
        <path
          d="M39.4647 20.3563L35.6401 36.2671C35.4601 37.0165 34.6277 37.4025 33.9453 37.0468L29.1083 34.5262L26.821 38.3033C26.1986 39.3327 24.6237 38.8861 24.6237 37.6826V33.474C24.6237 33.1485 24.7587 32.8382 24.9912 32.6111L34.4177 23.5279C34.4102 23.4143 34.2903 23.3159 34.1703 23.3992L22.9214 31.3016L19.1418 29.3336C18.2568 28.8718 18.2943 27.5775 19.2093 27.1763L37.8449 18.9787C38.7373 18.5851 39.6972 19.395 39.4647 20.3563Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_2188_104"
            x="0.5"
            y="0.876953"
            width="56"
            height="58"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.180392 0 0 0 0 0.27451 0 0 0 0 0.780392 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2188_104"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2188_104"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    twitter: (
      <svg
        className={className}
        width="57"
        height="59"
        viewBox="0 0 57 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2188_107)">
          <circle cx="28.5" cy="28.877" r="28" fill="#6379EF" />
          <circle
            cx="28.5"
            cy="28.877"
            r="27"
            stroke="#051D9C"
            strokeWidth="2"
          />
        </g>
        <path
          d="M19.5453 19.877L26.7394 29.496L19.5 37.3167H21.1294L27.4677 30.4694L32.5886 37.3167H38.1333L30.5343 27.1567L37.2728 19.877H35.6433L29.8063 26.183L25.09 19.877H19.5453ZM21.9415 21.0771H24.4887L35.7368 36.1166H33.1896L21.9415 21.0771Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_2188_107"
            x="0.5"
            y="0.876953"
            width="56"
            height="58"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0627451 0 0 0 0 0.133333 0 0 0 0 0.509804 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2188_107"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2188_107"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    copy: (
      <svg
        className={className}
        width="39"
        height="39"
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="group-hover:fill-[#7e91f5] transition-all duration-300 ease-in-out"
          d="M22.75 13H6.5C4.70762 13 3.25 14.4576 3.25 16.25V32.5C3.25 34.2924 4.70762 35.75 6.5 35.75H22.75C24.5424 35.75 26 34.2924 26 32.5V16.25C26 14.4576 24.5424 13 22.75 13Z"
          fill="white"
        />
        <path
          className="group-hover:fill-[#7e91f5] transition-all duration-300 ease-in-out"
          d="M32.5 3.25H16.25C15.388 3.25 14.5614 3.59241 13.9519 4.2019C13.3424 4.8114 13 5.63805 13 6.5V9.75H26C26.862 9.75 27.6886 10.0924 28.2981 10.7019C28.9076 11.3114 29.25 12.138 29.25 13V26H32.5C33.362 26 34.1886 25.6576 34.7981 25.0481C35.4076 24.4386 35.75 23.612 35.75 22.75V6.5C35.75 5.63805 35.4076 4.8114 34.7981 4.2019C34.1886 3.59241 33.362 3.25 32.5 3.25Z"
          fill="white"
        />
      </svg>
    ),
    minus: (
      <svg
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M40 23H0V17H40V23Z" fill="#051D9C" />
      </svg>
    ),
    plus: (
      <svg
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M38 22.5714H22.5714V38H17.4286V22.5714H2V17.4286H17.4286V2H22.5714V17.4286H38V22.5714Z"
          fill="white"
        />
      </svg>
    ),
  };
  return icon && iconsList[icon];
};

export default Icons;
